// Stable, non-hashed class per internal part, keyed off a consumer's own data-testid (e.g.
// "gender-select-input__formik-text-field__core"), so page SCSS/Cypress can target a part
// without reaching into CSS-Modules-hashed internals.
const makeStableClassName =
	(dataTestId: string | undefined) =>
	(part: string): string | undefined =>
		dataTestId ? `${dataTestId}__${part}` : undefined;

export { makeStableClassName };
